import Vue from 'vue'

import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import '@/plugins/css/custom.scss'

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
